import { render, staticRenderFns } from "./UnlayerEmailBroadcastWizardModal.vue?vue&type=template&id=f20ce25e&scoped=true"
import script from "./UnlayerEmailBroadcastWizardModal.vue?vue&type=script&lang=js"
export * from "./UnlayerEmailBroadcastWizardModal.vue?vue&type=script&lang=js"
import style0 from "./UnlayerEmailBroadcastWizardModal.vue?vue&type=style&index=0&id=f20ce25e&prod&lang=scss&scoped=true"
import style1 from "./UnlayerEmailBroadcastWizardModal.vue?vue&type=style&index=1&id=f20ce25e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20ce25e",
  null
  
)

export default component.exports